import {Injectable}                 from '@angular/core';
import { 
            HttpRequest, 
            HttpHandler, 
            HttpEvent, 
            HttpInterceptor}        from '@angular/common/http';
import { Observable }               from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { catchError }               from 'rxjs/operators';
import { throwError }               from 'rxjs';
import { UserService }              from '../_service/user.service';
import { CookieService }            from 'ngx-cookie-service';
import { TranslateService } from '@ngx-translate/core';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    redirect_to: string;

    constructor(
        private _userService: UserService,
        private _router: Router,
        private _translateService : TranslateService,
        private _cookieService: CookieService
    ) { }

    intercept(req: HttpRequest<any>,
        next: HttpHandler): Observable<HttpEvent<any>> {
        let csrf = this._cookieService.get("csrftoken");

        if (csrf) {
            req = req.clone({
                headers: req.headers.set("X-CSRFToken", csrf)
            });
        }

        return next.handle(req).pipe(
            catchError(error => {
                // checks if a url is to an admin api or not or token has expired or
                if (error.status === 401 || error.status === 403) {
                    this.logoutInitialize();
                }
                if (error.status === 500 || error.status === 409 || error.status === 400 ) {
                    return throwError(error.error || error);
                }
                if (error.status === 404 ) {
                    return throwError(this._translateService.instant("generic.not_found_error"));
                }
                if (error.status === undefined)
                {
                    console.log(error);
                    return throwError(error);
                }
            })
        );
    }

    logoutInitialize() 
    {
        localStorage.removeItem('auth_portal_user_info');
        sessionStorage.clear();
        // this._userService.logout().subscribe(
        //     data => {
        //         // this.redirect_to = this._router.url
        //         // this._router.navigate([""], { queryParams: { path: this.redirect_to } });
        //         localStorage.removeItem('auth_portal_user_info');
        //         sessionStorage.clear();
        //         // window.location.href = "/authportal/ui";
        //     },
        //     err => { 
        //         localStorage.removeItem('auth_portal_user_info');
        //         sessionStorage.clear();
        //         // window.location.href = "/authportal/ui";
        //     }
        // );

    }
}
